





























































































import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { ErrorManager } from '@/models/error';
import WorkflowFormSubmissionCommentListItem from './WorkflowFormSubmissionCommentListItem.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import auth from '@/mixins/auth';
import colorable from '@/mixins/colorable';
import mixins from '@/utils/mixins';
import {
  IWorkflowFormSubmissionComment,
  IWorkflowFormSubmission,
  IWorkflowFormSubmissionCommentData,
  WorkflowFormSubmissionComment,
  IUser,
  WorkflowFormSubmissionCommentAttachment,
  IWorkflowFormSubmissionCommentAttachment
} from '@/models';
import { PropType } from 'vue';
import QuillEditor from '../common/QuillEditor.vue';
import { isHtmlTextEmpty, setErrorFromAxiosError } from '@/utils/helpers';
import { AxiosError } from 'axios';
import WorkflowFormSubmissionCommentAttachmentList from './WorkflowFormSubmissionCommentAttachmentList.vue';

export default mixins(auth, colorable).extend({
  components: {
    ErrorAlert,
    QuillEditor,
    WorkflowFormSubmissionCommentListItem,
    WorkflowFormSubmissionCommentAttachmentList
  },
  name: 'WorkflowFormSubmissionCommentCard',

  props: {
    workflowFormSubmission: {
      type: Object as PropType<IWorkflowFormSubmission>,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },

  data: () => ({
    errorMessage: '',
    detailErrorMessage: '',

    commentValid: '',
    comment: {} as IWorkflowFormSubmissionCommentData,
    commentLoading: false,
    commentErrorMessage: '',
    commentDetailErrorMessage: '',
    mentionsLoading: false,

    attachments: [] as IWorkflowFormSubmissionCommentAttachment[]
  }),

  computed: {
    comments: get<IWorkflowFormSubmissionComment[]>(
      'workflowForm/getWorkflowFormSubmissionComments'
    ),

    mentionableUsers: get<IUser[]>(
      'workflowForm/getWorkflowFormSubmissionMentionableUsers'
    ),

    internalLoading: {
      get(): boolean {
        return this.loading;
      },
      set(value: boolean): void {
        this.$emit('update:loading', value);
      }
    },

    canSaveComment(): boolean {
      return !isHtmlTextEmpty(this.comment.text) && !this.commentLoading;
    }
  },

  methods: {
    ...mapActions({
      fetchWorkflowFormSubmissionComments:
        'workflowForm/fetchWorkflowFormSubmissionComments',
      createWorkflowFormSubmissionComment:
        'workflowForm/createWorkflowFormSubmissionComment',
      addWorkflowFormSubmissionCommentAttachments:
        'workflowForm/addWorkflowFormSubmissionCommentAttachments',
      fetchWorkflowFormSubmissionCommentsMentionableUsers:
        'workflowForm/fetchWorkflowFormSubmissionCommentsMentionableUsers'
    }),

    async loadMentionableUsers() {
      this.clearAllErrors();

      this.mentionsLoading = true;
      try {
        await this.fetchWorkflowFormSubmissionCommentsMentionableUsers(
          this.workflowFormSubmission.id
        );
      } catch (error) {
        this.commentErrorMessage = ErrorManager.extractApiError(
          error as AxiosError
        );
      } finally {
        this.mentionsLoading = false;
      }
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';

      this.commentErrorMessage = '';
      this.commentDetailErrorMessage = '';
    },

    addBaseAttachments(files: File[]) {
      this.attachments.push(
        ...files.map(
          file => new WorkflowFormSubmissionCommentAttachment({ file: file })
        )
      );
    },

    async addComment() {
      this.clearAllErrors();

      this.commentLoading = true;

      const parsedCommentMentionText = WorkflowFormSubmissionComment.parseHtmlToMentionText(
        this.comment.text
      );
      try {
        const commentId = (await this.createWorkflowFormSubmissionComment({
          submissionId: this.workflowFormSubmission.id,
          comment: { ...this.comment, text: parsedCommentMentionText }
        })) as Promise<number>;

        this.comment = {} as IWorkflowFormSubmissionCommentData;
        if (this.attachments.length !== 0) {
          await this.addWorkflowFormSubmissionCommentAttachments({
            submissionId: this.workflowFormSubmission.id,
            commentId: commentId,
            attachments: this.attachments
          });
          this.attachments = [];
        }
      } catch (error) {
        const commentError = setErrorFromAxiosError(error as AxiosError);
        this.commentErrorMessage = commentError.message;
        this.commentDetailErrorMessage = commentError.detail;
      } finally {
        this.commentLoading = false;
      }
    }
  },

  async mounted() {
    this.internalLoading = true;
    try {
      await this.fetchWorkflowFormSubmissionComments(
        this.workflowFormSubmission.id
      );
    } catch (err) {
      const error = err as AxiosError;
      if (error.response) {
        if (error.response.data.detail) {
          this.detailErrorMessage = error.response.data.detail;
        }
      }
      this.errorMessage = ErrorManager.extractApiError(error);
    } finally {
      this.internalLoading = false;
    }
  }
});
